export const GET_ALL_RISK_MANAGEMENT_SETTING = "GET_ALL_RISK_MANAGEMENT_SETTING"
export const GET_ALL_RISK_MANAGEMENT_SETTING_RESPONSE_SUCCESS =
  "GET_ALL_RISK_MANAGEMENT_SETTING_RESPONSE_SUCCESS"
